import type { Template } from "@/types";

export const PO_05_H3_V2: Template[] = [
{
    id: "po-05-h3v2-01",
    name: "PO 01 - H3V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h3_v2_01.png",
    size: [1136, 854],
    style: {},
        slots: [         
           { id: "1", x: 28, y: 208, width: 253, height: 437, rotation: 0, imageRotation: 0 },
           { id: "2", x: 289, y: 208, width: 252, height: 437, rotation: 0, imageRotation: 0 },
           { id: "3", x: 646, y: 208, width: 413, height: 283, rotation: 0, imageRotation: 0 },
           { id: "4", x: 646, y: 499, width: 202, height: 146, rotation: 0, imageRotation: 0 },
           { id: "5", x: 856, y: 499, width: 203, height: 146, rotation: 0, imageRotation: 0 }
        ],
},

{
    id: "po-05-h3v2-02",
    name: "PO 02 - H3V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h3_v2_02.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 39, y: 158, width: 484, height: 346, rotation: 0, imageRotation: 0 },
        { id: "2", x: 39, y: 512, width: 238, height: 184, rotation: 0, imageRotation: 0 },
        { id: "3", x: 285, y: 512, width: 238, height: 184, rotation: 0, imageRotation: 0 },
        { id: "4", x: 596, y: 208, width: 253, height: 437, rotation: 0, imageRotation: 0 },
        { id: "5", x: 857, y: 208, width: 252, height: 437, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h3v2-03",
    name: "PO 03 - H3V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h3_v2_03.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 40, y: 145, width: 489, height: 366, rotation: 0, imageRotation: 0 },
        { id: "2", x: 40, y: 519, width: 117, height: 190, rotation: 0, imageRotation: 0 },
        { id: "3", x: 165, y: 519, width: 239, height: 190, rotation: 0, imageRotation: 0 },
        { id: "4", x: 412, y: 519, width: 117, height: 190, rotation: 0, imageRotation: 0 },    
        { id: "5", x: 608, y: 243, width: 489, height: 367, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h3v2-04",
    name: "PO 04 - H3V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h3_v2_04.png",
    size: [1136, 854],
    style: {},
    slots: [     
        { id: "1", x: 27, y: 209, width: 253, height: 437, rotation: 0, imageRotation: 0 },
        { id: "2", x: 288, y: 209, width: 252, height: 437, rotation: 0, imageRotation: 0 },
        { id: "3", x: 612, y: 158, width: 238, height: 184, rotation: 0, imageRotation: 0 },
        { id: "4", x: 612, y: 350, width: 484, height: 346, rotation: 0, imageRotation: 0 },
        { id: "5", x: 858, y: 158, width: 238, height: 184, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h3v2-05",
    name: "PO 05 - H3V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h3_v2_05.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 0, y: 179, width: 322, height: 244, rotation: 0, imageRotation: 0 },
        { id: "2", x: 330, y: 179, width: 144, height: 244, rotation: 0, imageRotation: 0 },
        { id: "3", x: 0, y: 431, width: 144, height: 244, rotation: 0, imageRotation: 0 },
        { id: "4", x: 152, y: 431, width: 322, height: 244, rotation: 0, imageRotation: 0 },
        { id: "5", x: 482, y: 179, width: 654, height: 496, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h3v2-06",
    name: "PO 06 - H3V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h3_v2_06.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 0, y: 240, width: 450, height: 375, rotation: 0, imageRotation: 0 },
        { id: "2", x: 458, y: 240, width: 221, height: 375, rotation: 0, imageRotation: 0 },
        { id: "3", x: 687, y: 240, width: 220, height: 375, rotation: 0, imageRotation: 0 },
        { id: "4", x: 914, y: 240, width: 222, height: 184, rotation: 0, imageRotation: 0 },
        { id: "5", x: 914, y: 432, width: 222, height: 183, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h3v2-07",
    name: "PO 07 - H3V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h3_v2_07.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 75, y: 135, width: 343, height: 582, rotation: 0, imageRotation: 0 },       
        { id: "2", x: 426, y: 135, width: 379, height: 287, rotation: 0, imageRotation: 0 },
        { id: "3", x: 426, y: 430, width: 379, height: 287, rotation: 0, imageRotation: 0 },
        { id: "4", x: 813, y: 135, width: 247, height: 384, rotation: 0, imageRotation: 0 },
        { id: "5", x: 813, y: 528, width: 247, height: 189, rotation: 0, imageRotation: 0 },
    ],
},

{
    id: "po-05-h3v2-08",
    name: "PO 08 - H3V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h3_v2_08.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 63, y: 117, width: 364, height: 620, rotation: 0, imageRotation: 0 },       
        { id: "2", x: 435, y: 117, width: 267, height: 202, rotation: 0, imageRotation: 0 },
        { id: "3", x: 435, y: 327, width: 267, height: 201, rotation: 0, imageRotation: 0 },
        { id: "4", x: 435, y: 536, width: 267, height: 201, rotation: 0, imageRotation: 0 },
        { id: "5", x: 710, y: 117, width: 364, height: 620, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h3v2-09",
    name: "PO 09 - H3V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h3_v2_09.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 0, y: 240, width: 451, height: 375, rotation: 0, imageRotation: 0 },
        { id: "2", x: 459, y: 240, width: 221, height: 375, rotation: 0, imageRotation: 0 },     
        { id: "3", x: 688, y: 240, width: 220, height: 184, rotation: 0, imageRotation: 0 },
        { id: "4", x: 688, y: 432, width: 220, height: 183, rotation: 0, imageRotation: 0 },
        { id: "5", x: 916, y: 240, width: 220, height: 375, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h3v2-10",
    name: "PO 10 - H3V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h3_v2_10.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 63, y: 117, width: 365, height: 620, rotation: 0, imageRotation: 0 },
        { id: "2", x: 436, y: 117, width: 364, height: 620, rotation: 0, imageRotation: 0 },
        { id: "3", x: 808, y: 117, width: 266, height: 202, rotation: 0, imageRotation: 0 },
        { id: "4", x: 808, y: 327, width: 266, height: 201, rotation: 0, imageRotation: 0 },
        { id: "5", x: 808, y: 536, width: 266, height: 201, rotation: 0, imageRotation: 0 }
    ],
}
];